{{#with uvcProtocolCheckerAccessor}}
{{> class-definition}}
{{/with}}
